import { useEffect, useRef } from 'react'

const subscribers = new Set<(isOnline: boolean) => void>()
let initialized = false

let onlineHandler: (() => void) | null = null
let offlineHandler: (() => void) | null = null

const initGlobalListeners = (): void => {
  if (initialized || typeof window === 'undefined') return
  initialized = true
  onlineHandler = () => subscribers.forEach(cb => cb(true))
  offlineHandler = () => subscribers.forEach(cb => cb(false))
  window.addEventListener('online', onlineHandler)
  window.addEventListener('offline', offlineHandler)
}

// For testing/HMR cleanup if needed
export const cleanupGlobalListeners = (): void => {
  if (onlineHandler) window.removeEventListener('online', onlineHandler)
  if (offlineHandler) window.removeEventListener('offline', offlineHandler)
  initialized = false
  subscribers.clear()
}

export const useOnlineStatus = (onChange: (isOnline: boolean) => void): void => {
  const onChangeRef = useRef(onChange)
  onChangeRef.current = onChange

  useEffect(() => {
    initGlobalListeners()
    const handler = (isOnline: boolean) => onChangeRef.current(isOnline)
    subscribers.add(handler)
    return () => {
      subscribers.delete(handler)
    }
  }, [])
}
